import React, { createContext, useContext, useState } from 'react';
import en from './translations/en';
import pt from './translations/pt';
import fr from './translations/fr';

const translations = { en, pt, fr };

export const SUPPORTED_LANGUAGES = [
  { code: 'en', label: 'EN', flag: '🇨🇦' },
  { code: 'fr', label: 'FR', flag: '🇫🇷' },
  { code: 'pt', label: 'PT', flag: '🇧🇷' },
];

function detectBrowserLanguage() {
  const browserLang = navigator.language || navigator.userLanguage || 'en';
  if (browserLang.startsWith('pt')) return 'pt';
  if (browserLang.startsWith('fr')) return 'fr';
  return 'en';
}

function getInitialLanguage() {
  try {
    const saved = localStorage.getItem('preferredLanguage');
    if (saved && translations[saved]) return saved;
  } catch (e) {
    // localStorage not available
  }
  return detectBrowserLanguage();
}

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(getInitialLanguage);

  const setLanguage = (code) => {
    if (!translations[code]) return;
    setLanguageState(code);
    try {
      localStorage.setItem('preferredLanguage', code);
    } catch (e) {
      // ignore
    }
  };

  // Dot-notation key resolver: t('home.ctaBlog') → translations[lang].home.ctaBlog
  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      if (value == null) return key;
      value = value[k];
    }
    return value ?? key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, SUPPORTED_LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used inside <LanguageProvider>');
  return ctx;
}

export default LanguageContext;
